import React from 'react';
import './styles.css';

interface EducationCardProps {
    institution: string;
    time: string;
    description: string;
}

const EducationCard: React.FC<EducationCardProps> = ({institution, time, description}) => {
    return (
        <div className="education-card">
            <h1>{institution}</h1>
            <p>{time}</p>
            <p>{description}</p>
        </div>
    )
}

export default EducationCard